<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M4 2.666h7.899l4.08 13.556 3.124-10.434s1.345-3.122 4.123-3.122H28l-7.899 26.667h-8.029L4 2.666z"/></svg>
</template>

<script>
export default {
  name: 'brandVindi'
}
</script>
